import React, { useState } from "react";
import { styled } from "@mui/material/styles";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import {
  BORDER_GREY,
  BOX_SHADOW,
  BUTTON_BORDER_RADIUS,
  NAVBAR_BLUE,
  WHITE,
} from "~src/data/constant";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ModifiedFormControl = styled(FormControl)(() => ({
  margin: "10px",
  padding: "0 8px",
  border: `1px solid ${BORDER_GREY}`,
  borderRadius: BUTTON_BORDER_RADIUS,
  backgroundColor: WHITE,
  minWidth: 120,
}));

function FilterContainer({
  provider,

  handleFilterChange,
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ cursor: "pointer" }} onClick={() => setIsOpen(!isOpen)}>
      <div className="d-flex">
        <span style={{ color: NAVBAR_BLUE }}>Filters</span>
        <ArrowDropDownIcon color="primary" />
      </div>

      {isOpen && (
        <div
          className="position-absolute align-items-center justify-content-end p-4"
          style={{
            backgroundColor: "white",
            width: "38rem",
            height: "11.5rem",
            boxShadow: BOX_SHADOW,
            borderRadius: "10px",
            zIndex: 10,
          }}
        >
          <div className="d-flex">
            <div
              className="d-flex align-items-center"
              style={{
                color: NAVBAR_BLUE,
                fontSize: "16px",
                width: "7rem",
                height: "2rem",
              }}
            >
              Claim Type
            </div>
            <ModifiedFormControl
              className="mb-3 ms-5"
              variant="standard"
              size="small"
              sx={{
                display: "flex",
                justifyContent: "center",
                m: 0,
                width: "4rem",
                height: "2rem",
              }}
            >
              <Select
                id="claim-type"
                name="claim-type"
                value={provider["claim-type"]}
                onChange={handleFilterChange}
                disableUnderline
              >
                <MenuItem value="1">Initial</MenuItem>
                <MenuItem value="2">Resubmission</MenuItem>
              </Select>
            </ModifiedFormControl>
          </div>
          <div className="d-flex">
            <div
              className="d-flex align-items-center"
              style={{
                color: NAVBAR_BLUE,
                fontSize: "16px",
                width: "7rem",
                height: "2.5rem",
              }}
            >
              {" "}
              Claim Status
            </div>
            <ModifiedFormControl
              className="mb-3 p-1 ms-5"
              variant="standard"
              sx={{ width: 400, m: 0, height: "2.5rem" }}
            >
              <Select
                id="claim-status"
                name="claim-status"
                multiple
                value={provider["claim-status"]}
                onChange={handleFilterChange}
                disableUnderline
                renderValue={(selected) => (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 0.5,
                      height: "90%",
                    }}
                  >
                    {selected.map((value) => {
                      let label;
                      if (value === "open") {
                        label = "Open";
                      } else if (value === "paid") {
                        label = "Paid";
                      } else if (value === "partially_paid") {
                        label = "Partially Paid";
                      } else if (value === "rejected") {
                        label = "Rejected";
                      }
                      return (
                        <Chip
                          sx={{ height: "90%" }}
                          key={value}
                          label={label}
                        />
                      );
                    })}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                <MenuItem value="open">Open</MenuItem>
                <MenuItem value="paid">Paid</MenuItem>
                <MenuItem value="partially_paid">Partially Paid</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
              </Select>
            </ModifiedFormControl>
          </div>

          <div className="d-flex">
            <div
              className="d-flex align-items-center"
              style={{
                color: NAVBAR_BLUE,
                fontSize: "16px",
                width: "7rem",
                height: "2rem",
              }}
            >
              Encounter
            </div>
            <ModifiedFormControl
              className="mb-3 ms-5"
              variant="standard"
              size="small"
              sx={{
                display: "flex",
                justifyContent: "center",
                m: 0,
                width: 100,
                height: "2rem",
              }}
            >
              <Select
                id="encounter"
                name="encounter"
                value={provider.encounter}
                onChange={handleFilterChange}
                disableUnderline
              >
                <MenuItem value="inpatient">In Patient</MenuItem>
                <MenuItem value="outpatient">Out Patient</MenuItem>
                <MenuItem value="daycase">Day Case</MenuItem>
              </Select>
            </ModifiedFormControl>
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterContainer;
